import { defineStore } from 'pinia';
import { Schedule } from '@/entities/analytics-schedule';
import { useRRule } from '@/ui/concerns/rrule/useRRule';
import { Days, Repeat } from '@/entities/rrule/constants';
import { separateUsersAndGroups } from '@/ui/helpers';
import { scheduleRecord } from '@/ui/concerns/analytics/useSchedule';

interface State {
  id?: null | number;
  record: Schedule;
  version: string;
}

const {
  emptyMonthly,
  emptyWeekly,
} = useRRule();

export const useScheduleStore = defineStore('schedule', {
  state: (): State => ({
    id: null,
    record: scheduleRecord(),
    version: '',
  }),
  actions: {
    setId(id: number) {
      this.id = id;
    },
    setRecord(data: Schedule) {
      this.record = data;
    },
    setVersion(data: string) {
      this.version = data;
    },
    updateAssignees(value: string[]) {
      const { users, groups } = separateUsersAndGroups(value);

      this.record.assignees = users;
      this.record.assignedGroups = groups;
    },
    setRepeat(value: string) {
      this.record.rule.repeat = value;

      if (this.record.rule.repeat !== Repeat.Custom) {
        return;
      }

      if (!this.record.rule.frequency) {
        this.record.rule.frequency = Repeat.Weekly;
        this.record.rule.weekly = emptyWeekly();
      }
    },
    setFrequency(value: Repeat) {
      this.record.rule.frequency = value;

      if (value === Repeat.Weekly && !this.record.rule.weekly) {
        this.record.rule.weekly = emptyWeekly();
      }

      if (value === Repeat.Monthly && !this.record.rule.monthly) {
        this.record.rule.monthly = emptyMonthly();
      }
    },
    updateRuleStart(value: Date) {
      this.record.rule.start = value;
    },
    updateRuleInterval(value: number) {
      this.record.rule.interval = value;
    },
    changeDay(value: boolean, day: Days) {
      if (!this.record.rule.weekly) {
        this.record.rule.weekly = emptyWeekly();
      }

      this.record.rule.weekly[day] = value;
    },
    updateMonthDaysFrequency(value: string) {
      this.record.rule.monthly!.day = value;
    },
    updateMonthPosition(value: number) {
      this.record.rule.monthly!.setpos = value;
    },
  },
});
